export type AppConfig = {
  mode: "development" | "local" | "prod" | "test" | "uat";
  version?: string;
  sanityToken?: string;
  sanityDataset?: string;
  posthogKey?: string;
  posthogHost?: string;
  posthogEnabled?: string;
  posthogProjectId?: string;
};

export function getAppConfig(): AppConfig {
  const config = (window as unknown as { __APP_CONFIG__?: AppConfig })
    .__APP_CONFIG__;

  if (!config) {
    return {
      mode: (import.meta.env.VITE_MODE ?? "local") as AppConfig["mode"],
      sanityToken: import.meta.env.VITE_SANITY_TOKEN,
      sanityDataset: import.meta.env.VITE_SANITY_DATASET,
      posthogKey: import.meta.env.VITE_POSTHOG_KEY,
      posthogHost: import.meta.env.VITE_POSTHOG_HOST,
      posthogEnabled: import.meta.env.VITE_POSTHOG_ENABLED,
      posthogProjectId: import.meta.env.VITE_POSTHOG_PROJECT_ID,
    };
  }

  return config;
}
